import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { MultiSelect } from 'primereact/multiselect';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import LoadingScreen from '../../components/LoadingScreen';
import { dateToString } from 'src/utils/dateToString';
import { ModelOfDriver, ModelOfMotoristaVeiculo } from 'src/database';

import { useListDriversController } from '../../controllers/Driver/ListDriversController';
import classNames from 'classnames';
import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import { PulseLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar } from '@fortawesome/free-solid-svg-icons';
import { AutoComplete } from 'primereact/autocomplete';
import { Divider } from 'primereact/divider';

interface filteredProps {
	label: string;
	value?: string;
}

const DriversList: React.FC = () => {
	const { getDriverListController, handleDriverListController } = useListDriversController();
	const { vehicles } = getDriverListController
	const [valueVehicle, setValueVehicle] = useState('');
	const [filteredVehicle, setFilteredVehicle] = useState<filteredProps[]>([{ label: '', value: '' }]);

	const [globalFilter, setGlobalFilter] = useState<string | null>(null);

	if (getDriverListController.loading) {
		return <LoadingScreen />;
	}

	const searchVehicles = (event: any) => {
		let filteredVehicles;
		if (!event.query.trim().length) {
			filteredVehicles = [...vehicles];
		} else {
			filteredVehicles = vehicles.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredVehicle(filteredVehicles);
	};

	const cnhCategories = [
		{ label: 'A', value: 'A' },
		{ label: 'B', value: 'B' },
		{ label: 'C', value: 'C' },
		{ label: 'D', value: 'D' },
		{ label: 'E', value: 'E' },
	];

	const tableHeader = (
		<div className='table-header p-grid p-d-flex p-jc-between'>
			<h5 className='p-m-0'>Motoristas</h5>
			<span className='p-input-icon-left p-search-bar'>
				<i className='pi pi-search' />
				<InputText
					type='search'
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
					placeholder='Buscar...'
				/>
			</span>
		</div>
	);

	const actionBodyTemplate = (Driver: ModelOfDriver) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-text p-button-success p-mr-2'
					onClick={() => {
						handleDriverListController.openEditDialog(Driver)

					}
					}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => {
						handleDriverListController.openDeleteDialog(Driver)
					}
					}
				/>
				<Button
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => {
						handleDriverListController.openMotoristaVeiculoDialog(Driver)
					}
					}
				>
					<FontAwesomeIcon icon={faCar} />
				</Button>
			</React.Fragment>
		);
	};

	const editDriverDialogFooter = (
		<React.Fragment>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleDriverListController.closeEditDialog}
			/>
			<Button
				type='submit'
				label='Salvar'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getDriverListController.formik.handleSubmit();
				}}
			/>
		</React.Fragment>
	);

	const deleteDriverDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleDriverListController.closeDeleteDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getDriverListController.selectedDriver &&
						handleDriverListController.removeDriver(getDriverListController.selectedDriver);
				}}
			/>
		</React.Fragment>
	);

	const leftDriverToolbar = () => {
		return (
			<Link to='/driverForm'>
				<Button label='Cadastrar mostorista' icon='pi pi-plus' className='p-button-success p-mr-2' />
			</Link>
		);
	};

	const HEADER_NOME = (rowData: ModelOfDriver) => {
		return (
			<React.Fragment>
				<span className='left-header'>NOME</span>
				{rowData.NOME}
			</React.Fragment>
		);
	};

	const HEADER_CPF = (rowData: ModelOfDriver) => {
		return (
			<React.Fragment>
				<span className='left-header'>CPF</span>
				{rowData.CPF}
			</React.Fragment>
		);
	};

	const HEADER_CNH = (rowData: ModelOfDriver) => {
		return (
			<React.Fragment>
				<span className='left-header'>CNH</span>
				{rowData.CNH}
			</React.Fragment>
		);
	};

	const HEADER_CATEGORIACNH = (rowData: ModelOfDriver) => {
		return (
			<React.Fragment>
				<span className='left-header'>CATEGORIA CNH</span>
				{rowData.CATEGORIACNH}
			</React.Fragment>
		);
	};

	const HEADER_VALIDADECNH = (rowData: ModelOfDriver) => {
		return (
			<React.Fragment>
				<span className='left-header'>VALIDADE CNH</span>
				{dateToString(rowData.VALIDADECNH, 'br')}
			</React.Fragment>
		);
	};

	const HEADER_SENHA = (rowData: ModelOfDriver) => {
		return (
			<React.Fragment>
				<span className='left-header'>SENHA</span>
				{rowData.SENHA}
			</React.Fragment>
		);
	};

	const Loader: React.FC = ({ children }) => {
		const divRef: any = useRef<HTMLDivElement | null>(null);

		const [isVisible] = useIntersectionObserver({
			elementRef: divRef,
		});

		if (isVisible && !getDriverListController.maxData && !getDriverListController.loadingRows) {
			handleDriverListController.setRows(getDriverListController.rows + 20);
		}

		return (
			<div
				ref={divRef}
				style={{
					minHeight: '5px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{children}
			</div>
		);
	};

	const liberacaoMotoristaVeiculoDialogFooter = (
		<React.Fragment>
			<Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleDriverListController.closeEditDialog} />
			<Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getDriverListController.formikMotoristaVeiculo.handleSubmit() }} />
		</React.Fragment>
	);

	const HEADER_DATAINICIOMOTORISTAVEICULO = (rowData: ModelOfMotoristaVeiculo) => {
		return (
			<React.Fragment>
				<span className="left-header">Data Início</span>
				{dateToString(rowData.DATAINICIO, 'br')}
			</React.Fragment>
		)
	}

	const HEADER_DATAFIMCMOTORISTAVEICULO = (rowData: ModelOfMotoristaVeiculo) => {
		return (
			<React.Fragment>
				<span className="left-header">Data Fim</span>
				{dateToString(rowData.DATAFIM, 'br')}
			</React.Fragment>
		)
	}

	const actionBodyTemplateMotoristaVeiculo = (MotoristaVeiculo: ModelOfMotoristaVeiculo) => {
		return (
			<React.Fragment>
				<Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleDriverListController.editModtoristaVeiculo(MotoristaVeiculo)} />
				<Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleDriverListController.openDeleteMotoristaVeiculoDialog(MotoristaVeiculo)} />
			</React.Fragment>
		);
	};

	const deleteMotoristaVeiculoDialogFooter = (
		<React.Fragment>
			<Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleDriverListController.closeDeleteMotoristaVeiculoDialog} />
			<Button label="Sim" icon="pi pi-check" className="p-button-text"
				onClick={() => {
					handleDriverListController.selectedUnityMotoristaVeiculo && handleDriverListController.removeMotoristaVeiculo(handleDriverListController.selectedUnityMotoristaVeiculo)
				}}
			/>
		</React.Fragment>
	);

	const cellStyle = {
		fontSize: '10px' // Ajuste o tamanho da fonte para as células
	};
	return (
		<div>
			<Toast ref={getDriverListController.toast} />
			<div className='p-card p-p-4'>
				<Toolbar className='p-mb-4' left={leftDriverToolbar}></Toolbar>

				<DataTable
					header={tableHeader}
					globalFilter={globalFilter}
					rowHover
					className='responsive-table p-datatable-sm'
					dataKey='ID'
					autoLayout
					scrollable
					scrollHeight={'32em'}
					value={getDriverListController.driversData}>
					<Column field='NOME' header='NOME' body={HEADER_NOME} bodyStyle={cellStyle}></Column>
					<Column field='CPF' header='CPF' body={HEADER_CPF}  bodyStyle={cellStyle}></Column>
					<Column field='CNH' header='CNH' body={HEADER_CNH}  bodyStyle={cellStyle}></Column>
					<Column field='CATEGORIACNH' header='CATEGORIA CNH' body={HEADER_CATEGORIACNH}  bodyStyle={cellStyle}></Column>
					<Column field='VALIDADECNH' header='VALIDADE CNH' body={HEADER_VALIDADECNH}  bodyStyle={cellStyle}></Column>
					<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
				</DataTable>
				{/* <Loader>{!getDriverListController.maxData ?
                    getDriverListController.loadingRows ? <PulseLoader color="#0388e5" size={8} /> : <></>
                    : "Lista completa"}
                </Loader> */}
			</div>

			<Dialog
				className='p-fluid dropdown-visible'
				style={{ width: '90%' }}
				visible={getDriverListController.editDialog}
				onHide={handleDriverListController.closeEditDialog}
				onShow={() => {
					getDriverListController.formik.setValues({
						...getDriverListController.selectedDriver,
						DATANASCIMENTO: dateToString(getDriverListController.selectedDriver.DATANASCIMENTO, 'br'),
						VALIDADECNH: dateToString(getDriverListController.selectedDriver.VALIDADECNH, 'br'),
						LOGIN: '',
						NIVEL: 1,
						CATEGORIACNH: getDriverListController.selectedDriver.CATEGORIACNH.split(','),
					});
				}}
				footer={editDriverDialogFooter}
				header={`Editar motorista ${getDriverListController.selectedDriver?.NOME}`}
				modal>
				{getDriverListController.loadingEdit ? <LoadingScreen color='#0388e5' /> : <></>}
				<div className='p-grid p-fluid'>
					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='cpf'>CPF</label>
						<InputMask
							id='cpf'
							disabled
							mask='999.999.999-99'
							{...getDriverListController.formik.getFieldProps('CPF')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.CPF &&
									getDriverListController.formik.errors.CPF,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.CPF &&
									getDriverListController.formik.errors.CPF
								),
							})}>
							{getDriverListController.formik.errors.CPF}
						</div>
					</div>

					<div className='p-field p-col-12 p-md-8'>
						<label htmlFor='nomeComp'>Nome completo</label>
						<InputText
							id='nomeComp'
							{...getDriverListController.formik.getFieldProps('NOME')}
							onChange={getDriverListController.formik.handleChange('NOME')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.NOME &&
									getDriverListController.formik.errors.NOME,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.NOME &&
									getDriverListController.formik.errors.NOME
								),
							})}>
							{getDriverListController.formik.errors.NOME}
						</div>
					</div>

					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='dataNac'>Data de nascimento</label>
						<InputMask
							mask='99/99/9999'
							placeholder='__/__/____'
							{...getDriverListController.formik.getFieldProps('DATANASCIMENTO')}
							onChange={e => getDriverListController.formik.setFieldValue('DATANASCIMENTO', e.value)}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.DATANASCIMENTO &&
									getDriverListController.formik.errors.DATANASCIMENTO,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.DATANASCIMENTO &&
									getDriverListController.formik.errors.DATANASCIMENTO
								),
							})}>
							{getDriverListController.formik.errors.DATANASCIMENTO}
						</div>
					</div>

					<div className='p-field p-col-12 p-md-8'>
						<label htmlFor='numCNH'>Nº de registro CNH</label>
						<InputText
							id='numCNH'
							maxLength={150}
							{...getDriverListController.formik.getFieldProps('CNH')}
							onChange={getDriverListController.formik.handleChange('CNH')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.CNH &&
									getDriverListController.formik.errors.CNH,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.CNH &&
									getDriverListController.formik.errors.CNH
								),
							})}>
							{getDriverListController.formik.errors.CNH}
						</div>
					</div>

					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='catCNH'>Categoria CNH</label>
						<MultiSelect
							id='catCNH'
							inputId='catCNH'
							{...getDriverListController.formik.getFieldProps('CATEGORIACNH')}
							onChange={e => {
								getDriverListController.formik.setFieldValue('CATEGORIACNH', e.value);
							}}
							options={cnhCategories}
							optionLabel='label'
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.CATEGORIACNH &&
									getDriverListController.formik.errors.CATEGORIACNH,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.CATEGORIACNH &&
									getDriverListController.formik.errors.CATEGORIACNH
								),
							})}>
							{getDriverListController.formik.errors.CATEGORIACNH}
						</div>
					</div>

					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='valCNH'>Validade CNH</label>
						<InputMask
							mask='99/99/9999'
							placeholder='__/__/____'
							{...getDriverListController.formik.getFieldProps('VALIDADECNH')}
							onChange={e => getDriverListController.formik.setFieldValue('VALIDADECNH', e.value)}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.VALIDADECNH &&
									getDriverListController.formik.errors.VALIDADECNH,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.VALIDADECNH &&
									getDriverListController.formik.errors.VALIDADECNH
								),
							})}>
							{getDriverListController.formik.errors.VALIDADECNH}
						</div>
					</div>



					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='nomeComp'>Senha</label>
						<InputText
							id='senha'
							{...getDriverListController.formik.getFieldProps('SENHA')}
							onChange={getDriverListController.formik.handleChange('SENHA')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getDriverListController.formik.touched.SENHA &&
									getDriverListController.formik.errors.SENHA,
								'popup-form-inactive': !(
									getDriverListController.formik.touched.SENHA &&
									getDriverListController.formik.errors.SENHA
								),
							})}>
							{getDriverListController.formik.errors.SENHA}
						</div>
					</div>

				</div>
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getDriverListController.deleteDialog}
				onHide={handleDriverListController.closeDeleteDialog}
				footer={deleteDriverDialogFooter}
				header='Remover motorista'
				modal>
				<div className='confirmation-content'>
					<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
					{getDriverListController.selectedDriver && (
						<span>
							Você tem certeza que deseja remover <b>{getDriverListController.selectedDriver.NOME}</b>?
						</span>
					)}
				</div>
			</Dialog>


			<Dialog
				className="p-fluid"
				style={{ width: '750px' }}
				visible={getDriverListController.motoristaVeiculoDialog}
				onHide={handleDriverListController.closeMotoristaVeiculoDialog}
				onShow={() => (
					getDriverListController.formik.setFieldValue('ID', getDriverListController.selectedDriver?.ID),
					getDriverListController.formik.setFieldValue('DESCRICAO', getDriverListController.selectedDriver?.NOME),
					getDriverListController.getMotoristaVeiculos())

				}
				footer={liberacaoMotoristaVeiculoDialogFooter}
				header={`Vincula motorista: ${getDriverListController.selectedDriver.NOME}`}
				modal
			>


				<div className='p-field p-col-12 p-md-12'>
					<label htmlFor='descricao'>Veículo</label>
					<AutoComplete
						id='vehicle'
						value={valueVehicle}
						field='label'
						onChange={e => {
							if (typeof e.value === 'string') {
								setValueVehicle(e.value);
								getDriverListController.formikMotoristaVeiculo.setFieldValue('FT_VEICULO', '');
							} else {
								setValueVehicle(e.value?.label || '');
								getDriverListController.formikMotoristaVeiculo.setFieldValue(
									'FT_VEICULO',
									e.value?.value || '',
								);
							}
						}}
						onSelect={e => {
							setValueVehicle(e.value.label);
							getDriverListController.formikMotoristaVeiculo.setFieldValue('FT_VEICULO', e.value.value);
						}}
						suggestions={filteredVehicle}
						completeMethod={searchVehicles}
						dropdown
						forceSelection={false}
						placeholder='Selecione o veículo...'
					/>
					<div className={classNames("p-invalid popup-fade", {
						'popup-form-active': getDriverListController.formikMotoristaVeiculo.touched.FT_VEICULO && getDriverListController.formikMotoristaVeiculo.errors.FT_VEICULO,
						'popup-form-inactive': !(getDriverListController.formikMotoristaVeiculo.touched.FT_VEICULO && getDriverListController.formikMotoristaVeiculo.errors.FT_VEICULO),
					})}
					>{getDriverListController.formikMotoristaVeiculo.errors.FT_VEICULO}</div>
				</div>

				<div className='p-grid p-col-12 p-md-12'>
					<div className='p-col-6 p-md-6'>
						<label htmlFor='descricao'>Data Inicio Liberação</label>
						<InputMask
							type={'text'}
							mask='99/99/9999'
							value={getDriverListController.formikMotoristaVeiculo.values.DATAINICIO}
							onChange={e => {
								getDriverListController.formikMotoristaVeiculo.setFieldValue('DATAINICIO', e.target.value);
							}}
							placeholder='__/__/____'
						/>
						<div className={classNames("p-invalid popup-fade", {
							'popup-form-active': getDriverListController.formikMotoristaVeiculo.touched.DATAINICIO && getDriverListController.formikMotoristaVeiculo.errors.DATAINICIO,
							'popup-form-inactive': !(getDriverListController.formikMotoristaVeiculo.touched.DATAINICIO && getDriverListController.formikMotoristaVeiculo.errors.DATAINICIO),
						})}
						>{getDriverListController.formikMotoristaVeiculo.errors.DATAINICIO}</div>
					</div>

					<div className='p-col-6 p-md-6'>
						<label htmlFor='descricao'>Data Fim Liberação</label>
						<InputMask
							type={'text'}
							mask='99/99/9999'
							value={getDriverListController.formikMotoristaVeiculo.values.DATAFIM}
							onChange={e => {
								getDriverListController.formikMotoristaVeiculo.setFieldValue('DATAFIM', e.target.value);
							}}
							placeholder='__/__/____'
						/>
						<div className={classNames("p-invalid popup-fade", {
							'popup-form-active': getDriverListController.formikMotoristaVeiculo.touched.DATAFIM && getDriverListController.formikMotoristaVeiculo.errors.DATAFIM,
							'popup-form-inactive': !(getDriverListController.formikMotoristaVeiculo.touched.DATAFIM && getDriverListController.formikMotoristaVeiculo.errors.DATAFIM),
						})}
						>{getDriverListController.formikMotoristaVeiculo.errors.DATAFIM}</div>
					</div>
				</div>
				<div className='p-col-6 p-md-6'>
					<label>Veículo(s) vinculado ao motorista</label>
				</div>
				<Divider style={{ borderTop: '3px solid #191970', margin: '3px 0' }} />
				<div className="p-card p-p-4 datatable-container">

					<DataTable className="p-datatable-sm"
						dataKey="ID" rowHover scrollable scrollHeight={'100%'}
						value={getDriverListController.unityMotoristaVeiculoData}>
						<Column field="PLACA" header="Placa"></Column>
						<Column style={{ width: '200px' }} field="DESCRICAOVEICULO" header="Veículo"></Column>
						<Column field="DATAINICIO" header="Data Inicio" body={HEADER_DATAINICIOMOTORISTAVEICULO}></Column>
						<Column field="DATAFIM" header="Data Fim" body={HEADER_DATAFIMCMOTORISTAVEICULO}></Column>
						<Column body={actionBodyTemplateMotoristaVeiculo} bodyStyle={{ textAlign: 'right' }}></Column>

					</DataTable>
				</div>


			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getDriverListController.deleteMotoristaVeiculoDialog}
				onHide={handleDriverListController.closeDeleteMotoristaVeiculoDialog}
				footer={deleteMotoristaVeiculoDialogFooter}
				header="Remover veículo"
				modal
			>
				<div className="confirmation-content">
					<i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
					{handleDriverListController.selectedUnityMotoristaVeiculo && <span>Você tem certeza que deseja remover <b>{handleDriverListController.selectedUnityMotoristaVeiculo.DESCRICAOVEICULO}</b>?</span>}
				</div>
			</Dialog>



		</div>
	);
};

export default DriversList;
